const Configs = {
  STORE_URL: process.env.REACT_APP_STORE_URL,
  API_URL: process.env.REACT_APP_API_URL,
  FCM_CONFIG: {
    apiKey: process.env.REACT_APP_FCM_API_KEY,
    authDomain: process.env.REACT_APP_FCM_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FCM_DATABASE_URL,
    projectId: process.env.REACT_APP_FCM_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FCM_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FCM_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FCM_APP_ID,
  },
  GPS_CONFIG: {
    apiKey: process.env.REACT_APP_GPS_API_KEY,
  },
  APP_VERSION: process.env.REACT_APP_VERSION,
  ACC_URL: process.env.REACT_APP_ACC_URL,
  DOMAIN: process.env.REACT_APP_DOMAIN,
  RecaptchaConst: process.env.REACT_APP_RECAPTCHA_KEY,
  MODE: process.env.REACT_APP_MODE,
  REDUX_ENCRYPTOR_KEY: process.env.REACT_APP_REDUX_ENCRYPTOR_KEY,
  FULLSTORY_IDS: JSON.parse(process.env.REACT_APP_FULLSTORY_IDS || "[]"),
  CHARGEBEE_PUBLISH_KEY: process.env.REACT_APP_CHARGEBEE_PUBLISH_KEY,
  CHARGEBEE_SITE: process.env.REACT_APP_CHARGEBEE_SITE,
  GLOBAL_TOKEN: process.env.REACT_APP_GLOBAL_TOKEN,
  SUMHR_CAREER_KEY: process.env.REACT_APP_SUMHR_CAREER_KEY,
};

export default Configs;
